import { PointerEvent } from "react";

import { PointerSensor, PointerSensorOptions } from "@dnd-kit/core";

/**
 * Custom pointer sensor that prevents dragging when interacting with interactive elements
 *
 * @note extends PointerSensor from @dnd-kit/core
 */
export class CustomPointerSensor extends PointerSensor {
    static activators = [
        {
            eventName: "onPointerDown" as const,
            handler: ({ nativeEvent: event }: PointerEvent, { onActivation }: PointerSensorOptions) => {
                // Basic pointer check from original sensor
                if (!event.isPrimary || event.button !== 0) {
                    return false;
                }

                // Check if the target is an interactive element
                if (event.target instanceof Element) {
                    const target = event.target as HTMLElement;
                    const interactiveElement = target.closest(
                        'input, textarea, [contenteditable="true"], select, button'
                    );

                    if (interactiveElement) {
                        return false;
                    }
                }

                onActivation?.({ event });
                return true;
            },
        },
    ];
}
